module.exports = __webpack_public_path__ + "static/img/logo2-bai.b5e85820.png";